import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { TitledPageComponent } from 'src/app/shared/components/titled-page/titled-page.component';

@Component({
  selector: 'app-log-ins',
  standalone: true,
  imports: [CommonModule, RouterOutlet, TitledPageComponent],
  templateUrl: './log-ins.component.html',
  styleUrls: ['./log-ins.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogInsComponent {}
